module.exports = __webpack_public_path__ + "media/images/DailyHerald-black-cd99979814dd1b052503beaabf89a26e.png";